import generateConstantLifecycle from 'utils/generateConstantLifecycle';

export const READ_ORGANIZATIONS_BY_USER = 'READ_ORGANIZATIONS_BY_USER';
export const READ_ORGANIZATION_TWILIO_REGISTRATIONS =
  'READ_ORGANIZATION_TWILIO_REGISTRATIONS';
export const READ_ORGANIZATION = 'READ_ORGANIZATION';
export const UPDATE_ORGANIZATION = 'UPDATE_ORGANIZATION';

export const constants = {
  ...generateConstantLifecycle(
    READ_ORGANIZATIONS_BY_USER,
    READ_ORGANIZATION_TWILIO_REGISTRATIONS,
    READ_ORGANIZATION,
    UPDATE_ORGANIZATION,
  ),
};
